import axios, { type AxiosResponse } from 'axios'

export type SuccessCollectInfo = {
	show_total: boolean
	amount_collected: number
	amount_collected_before_this_transaction: number
	amount_paid: string
	collector_name: string
	collector_picture: string
	sender_email: string
	collect_name?: string
	slug?: string
}

export const successService = {
	getSuccessCollectInfo: async ({
		transactionIdentifier,
		collectSlug
	}: {
		transactionIdentifier: string
		collectSlug: string
	}): Promise<SuccessCollectInfo> => {
		return axios
			.get(
				`${process.env.REACT_APP_POTS_URL}collect/successCollectInfo?transaction_identifier=${transactionIdentifier}&collect_slug=${collectSlug}`
			)
			.then((res: AxiosResponse<SuccessCollectInfo>) => res.data)
	}
}

export const successLydiaPageService = {
	getSuccessLydiaPageInfo: async (transactionIdentifier: string): Promise<SuccessCollectInfo> => {
		return axios
			.get(
				`${process.env.REACT_APP_POTS_URL}collect/successLydiaPageInfo?identifier=${transactionIdentifier}`
			)
			.then((res: AxiosResponse<SuccessCollectInfo>) => res.data)
	}
}
